import * as angular from 'angular';
import * as _ from "lodash";
import {IController, ILogService, ITimeoutService} from 'angular';
import {ServiceType} from "../../../deliveries/types/service.type";
import {VisitConfigurationFacadeService} from "../../angular/services/visit-configuration-facade.service";
import {Subscription} from "rxjs";
import {VisitConfigurationModel} from "../../models/visit-configuration.model";
import {
  VisitConfigurationImportRow,
  VisitConfigurationsDialogService
} from "../../services/visit-configurations-dialog.service";
import {AccountModel} from "../../../account/angular/models/account.model";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";
import {DateRangeTemplateType} from "../../../commons/types/date-range-template.type";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {SchedulingProjectRequests} from "../../services/scheduling-project-requests.service";
import {BatchRequestsService} from "../../../batch/services/batch-requests.service";
import {SchedulingProjectAlertsService} from "../../services/scheduling-project-alerts.service";
import {ProcessTrackingModel} from "../../../commons/models/process-tracking.model";
import {ProcessTrackingStatusEnum} from "../../../commons/types/process-tracking-status.enum";
import {CallTemplatesQuery} from "../../angular/services/visit-configuration-http.service";
import {ImportVerification} from "../../../commons/models/import-verification.model";
import {AnalyticsService} from "../../../commons/services/analytics-service.service";

export interface VisitConfigurationTotals {
  total: number;
  active: number;
  inactive: number;
}

export class VisitConfigurationsViewComponent implements IController {
  from?: number;
  to?: number;
  dateRangeTemplateType: DateRangeTemplateType;
  ids?: string[];
  serviceTypes?: ServiceType;
  programTypes?: string[];
  branchIds?: string[];
  accountIds?: string[] = [];
  account?: AccountModel;

  public visitConfigurations: VisitConfigurationModel[];
  public visitConfigurationTotals: VisitConfigurationTotals;
  public isLoading: boolean;
  public serviceTypeOptions: typeof ServiceType = ServiceType;
  public filterConfig: any;
  public selectedIds: string[] = [];

  private listSubscription: Subscription;
  private isLoadingSubscription: Subscription;
  /* @ngInject */
  constructor(
    private visitConfigurationFacadeService: VisitConfigurationFacadeService,
    private visitConfigurationsDialogService: VisitConfigurationsDialogService,
    private commonsAlertsService: CommonsAlertsService,
    private confirmDialogService: ConfirmDialogService,
    private dateRangeTimeFiltersService: DateRangeTimeFiltersService,
    private schedulingProjectRequests: SchedulingProjectRequests,
    private batchRequestsService: BatchRequestsService,
    private schedulingProjectAlertsService: SchedulingProjectAlertsService,
    private analyticsService: AnalyticsService,
    private $timeout: ITimeoutService,
    private $log: ILogService,
    private $state
  ) {

  }

  $onInit() {

    this.filterConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: this.dateRangeTemplateType ? this.dateRangeTimeFiltersService.getDateRangeFilterByType(this.dateRangeTemplateType) :
        ((this.from && this.to) ? {
          dateStart: this.from,
          dateEnd: this.to
        } : this.dateRangeTimeFiltersService.thisMonth()),
      includeFilters: [
        SiteFiltersType.dateRangeTemplateType,
        SiteFiltersType.serviceTypes,
        SiteFiltersType.programTypes,
        SiteFiltersType.branchIds
      ],
      bringozFilters: {
        [SiteFiltersType.dateRangeTemplateType]: this.dateRangeTemplateType,
        [SiteFiltersType.serviceTypes]: this.serviceTypes || [],
        [SiteFiltersType.programTypes]: this.programTypes || [],
        [SiteFiltersType.branchIds]: this.branchIds || []
      }
    };

    if (!this.account) {
      this.filterConfig.includeFilters.push(SiteFiltersType.accountIds);
      this.filterConfig.bringozFilters[SiteFiltersType.accountIds] = this.accountIds || [];
    }

    this.listSubscription = this.visitConfigurationFacadeService.selectAll().subscribe(visitConfigurations => {
      this.visitConfigurations = angular.copy(visitConfigurations);
      this.$timeout(() => {
      }, 0)
    });

    this.isLoadingSubscription = this.visitConfigurationFacadeService.selectIsLoading().subscribe((isLoading) => {
      this.isLoading = isLoading;
      this.$timeout(() => {
      }, 0)
    });

    this._getVisitConfigurations(this.getQueryParams());
  }

  $onDestroy() {
    this.visitConfigurationFacadeService.clearStore();
    this.listSubscription.unsubscribe();
    this.isLoadingSubscription.unsubscribe();
  }

  onQueryStringChanged(queryString) {
    this.filterConfig.queryString = queryString;
    this._getVisitConfigurations(this.getQueryParams())
  }

  onRangeChanged(range) {
    this.filterConfig.range = range;
    this.filterConfig.range.dateRangeTemplateType = this.dateRangeTimeFiltersService.getDateRangeFilterByType(range.type)?.type;
    this.filterConfig.bringozFilters.dateRangeTemplateType = this.filterConfig.range.dateRangeTemplateType;

    this._setQueryParams();
    this._getVisitConfigurations(this.getQueryParams())
  }

  onFiltersChange(filters, selectedQuickFilter?) {
    this.analyticsService.trackEvent('Visit Configurations Actions', 'visit_config_filters_changed', this._getActiveFiltersSummary(filters));
    this.filterConfig.bringozFilters = filters;

    this._setQueryParams();
    this._getVisitConfigurations(this.getQueryParams())
  }

  fetchNext() {
    this.visitConfigurationFacadeService.fetchNext(this.getQueryParams());
  }


  onCreate($event: any, serviceType: ServiceType) {
    this.visitConfigurationsDialogService.createVisitConfiguration(serviceType, this.account?.id, this.account?.branchIds, $event)
      .then((visitConfiguration: VisitConfigurationModel) => {
        this._createVisitConfiguration(visitConfiguration);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onEdit(visitConfiguration) {
    this.visitConfigurationsDialogService.editVisitConfiguration(visitConfiguration)
      .then((visitConfiguration: VisitConfigurationModel) => {
        this._updateVisitConfiguration(visitConfiguration);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onDelete(id: string, event?) {
    this.confirmDialogService.confirm('Delete Projection Template', 'Are you sure you want to delete this projection template?', event)
      .then(() => {
        this._deleteVisitConfiguration(id);
      })
      .catch(err => {
        this.$log.info('Dialog Closed');
      })
  }

  onBulkExpire(event) {
    this.analyticsService.trackEvent('Visit Configurations Actions', 'bulk_expire_clicked', this.selectedIds.length);
    if (_.isEmpty(this.visitConfigurations)) {
      this.schedulingProjectAlertsService.bulkExpireVisitConfigurationsEmptyListInfo();
      return;
    }

    const {searchTerm, ids, serviceTypes, programTypes, branchIds, accountIds} = this.getQueryParams();
    if (!this.selectedIds.length && [searchTerm, ids, serviceTypes, programTypes, branchIds, accountIds].every(_.isEmpty)) {
      this.schedulingProjectAlertsService.bulkExpireVisitConfigurationsNoFiltersInfo();
      return;
    }

    this.visitConfigurationsDialogService.expireVisitConfigurations(event)
      .then((expirationDate: number) => {
        this.analyticsService.trackEvent('Visit Configurations Actions', 'bulk_expire_confirmed', expirationDate);
        this._bulkExpireVisitConfigurations(expirationDate);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onSelectVisitConfigurations(selectedIds: string[]) {
    this.selectedIds = selectedIds;
  }

  onClearSelection() {
    this.selectedIds = [];
  }

  uploadFiles(files, invalidFiles) {
    let file = files && files.length ? files[0] : undefined;
    if(!file) {
      return;
    }
    if (invalidFiles.length>0) {
      this.commonsAlertsService.fileFormatError();
    }
    this.schedulingProjectRequests.validateVisitConfiguration(file)
      .then((rows: ImportVerification<VisitConfigurationModel>[]) => {
        return this.visitConfigurationsDialogService.reviewUploadedVisitConfigurations(rows)
          .then((rowsToUpload: VisitConfigurationImportRow[]) => {
            // Not returned into the dialog chain, so a failed upload isn't reported as a cancel.
            this._uploadVisitConfigurations(rowsToUpload);
          })
          .catch(() => {
            this.$log.info('Dialog Closed');
          });
    }).catch(err => {
      this.$log.error('Failed to validate visit configurations', err);
      this.schedulingProjectAlertsService.importVisitConfigurationsFailed(err);
    })
  }

  private _uploadVisitConfigurations(rowsToUpload: VisitConfigurationImportRow[]) {
    this.batchRequestsService.uploadVisitConfigurations(rowsToUpload)
      .then(() => {
        this.schedulingProjectAlertsService.uploadVisitConfigurationsSuccess();
      })
      .catch(err => {
        this.$log.error('Failed to upload visit configurations', err);
        this.schedulingProjectAlertsService.importVisitConfigurationsFailed();
      });
  }

  private _getVisitConfigurations(params) {
    this.selectedIds = [];
    this.visitConfigurationFacadeService.clearStore();
    this.visitConfigurationFacadeService.getMany(params);

    this._getVisitConfigurationsTotals();
  }

  private _getVisitConfigurationsTotals() {
    this.visitConfigurationTotals = undefined;

    const totalsParams = {
      ids: this.ids,
      accountIds: !!this.account ? [this.account.id] : this.filterConfig.bringozFilters.accountIds,
      serviceTypes: this.filterConfig.bringozFilters.serviceTypes,
      programTypes: this.filterConfig.bringozFilters.programTypes,
      branchIds: this.filterConfig.bringozFilters.branchIds,
      searchTerm: this.filterConfig.queryString,
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd
    };
    Object.keys(totalsParams).forEach(key => totalsParams[key] === undefined && delete totalsParams[key]);

    this.visitConfigurationFacadeService.getVisitConfigurationTotals(totalsParams)
      .subscribe({
        next: (totals: VisitConfigurationTotals) => {
          this.visitConfigurationTotals = totals;
          this.$timeout(() => {
          }, 0)
        },
        error: (error) => {
          this.$log.error('Failed to get visit configuration totals', error);
        }
      });
  }

  private getQueryParams() {
    const params = {
      limit: 20,
      searchTerm: this.filterConfig.queryString,
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      ids: this.ids,
      serviceTypes: this.filterConfig.bringozFilters.serviceTypes,
      programTypes: this.filterConfig.bringozFilters.programTypes,
      branchIds: this.filterConfig.bringozFilters.branchIds,
      accountIds: !!this.account ? [this.account.id] : this.filterConfig.bringozFilters.accountIds,
    }

    Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);

    return params;
  }

  private _createVisitConfiguration(visitConfiguration: VisitConfigurationModel) {
    this.visitConfigurationFacadeService.createOne(visitConfiguration)
  }

  private _updateVisitConfiguration(visitConfiguration: VisitConfigurationModel) {
    this.visitConfigurationFacadeService.updateOne(visitConfiguration);
  }

  private _deleteVisitConfiguration(id: string) {
    this.visitConfigurationFacadeService.deleteOne(id);
  }

  private _bulkExpireVisitConfigurations(expirationDate: number) {
    if (this.selectedIds.length) {
      this._callExpire({expirationDate: expirationDate, ids: this.selectedIds});
      return;
    }

    const payload: CallTemplatesQuery = {
      expirationDate: expirationDate,
      searchTerm: this.filterConfig.queryString,
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      ids: this.ids,
      serviceTypes: this.filterConfig.bringozFilters.serviceTypes,
      programTypes: this.filterConfig.bringozFilters.programTypes,
      branchIds: this.filterConfig.bringozFilters.branchIds,
      accountIds: !!this.account ? [this.account.id] : this.filterConfig.bringozFilters.accountIds,
    };
    Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);

    this._callExpire(payload);
  }

  private _callExpire(payload) {
    this.visitConfigurationFacadeService.expireVisitConfigurations(payload)
      .subscribe({
        next: (processTracking: ProcessTrackingModel) => {
          this._trackBulkExpireProcess(processTracking);
        },
        error: (err) => {
          this.$log.error('Failed to bulk expire visit configurations', err);
          this.schedulingProjectAlertsService.bulkExpireVisitConfigurationsError(err?.error);
        }
      });
  }

  private _trackBulkExpireProcess(processTracking: ProcessTrackingModel) {
    if (!processTracking?.id) {
      this.schedulingProjectAlertsService.bulkExpireVisitConfigurationsSuccess();
      this._getVisitConfigurations(this.getQueryParams());
      return;
    }

    this.visitConfigurationsDialogService.expireVisitConfigurationsProcessing(processTracking)
      .then((result: { processTracking: ProcessTrackingModel, isDone: boolean }) => {
        this._onBulkExpireProcessDone(result?.processTracking, result?.isDone);
      })
      .catch((err) => {
        this.$log.error('Failed to track bulk expire visit configurations process', err);
        this.schedulingProjectAlertsService.bulkExpireVisitConfigurationsError(err?.error);
        this._getVisitConfigurations(this.getQueryParams());
      })
  }

  private _onBulkExpireProcessDone(processTracking: ProcessTrackingModel, isDone: boolean) {
    const hasFailed = processTracking?.processStatus === ProcessTrackingStatusEnum.FAIL || !!processTracking?.errors?.length;

    if (hasFailed || !isDone) {
      this.$log.error('Bulk expire visit configurations process did not complete', processTracking);
      this.schedulingProjectAlertsService.bulkExpireVisitConfigurationsError(undefined);
    } else {
      this.schedulingProjectAlertsService.bulkExpireVisitConfigurationsSuccess();
    }

    this._getVisitConfigurations(this.getQueryParams());
  }

  private _getActiveFiltersSummary(filters): string {
    return Object.keys(filters || {})
      .filter(key => _.isArray(filters[key]) ? filters[key].length : !!filters[key])
      .join(',');
  }

  private _setQueryParams() {
    this.$state.go('.', {
      from: this.filterConfig.range.dateStart,
      to: this.filterConfig.range.dateEnd,
      dateRangeTemplateType: this.filterConfig.bringozFilters.dateRangeTemplateType,
      serviceTypes: this.filterConfig.bringozFilters.serviceTypes,
      programTypes: this.filterConfig.bringozFilters.programTypes,
      branchIds: this.filterConfig.bringozFilters.branchIds,
      accountIds: this.filterConfig.bringozFilters.accountIds
    }, {
      notify: false,
      reload: false
    })
  }

}

angular
  .module('bringoz.admin.scheduling-project')
  .component('visitConfigurationsView', {
    bindings: {
      from: '<?',
      to: '<?',
      dateRangeTemplateType: '<?',
      ids: '<?',
      serviceTypes: '<?',
      programTypes: '<?',
      branchIds: '<?',
      accountIds: '<?',
      account: '<?'
    },
    template: require('./visit-configurations-view.html').default,
    controller: VisitConfigurationsViewComponent
  });
